import React, { useEffect, useState } from "react";
import "../../assets/styles/Search.css";
import "../../assets/styles/Profile.css";
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import HtmlNote from "../../components/Profile/HtmlNote.js";
import modalClose from "../../imgs/figma_icons/modal-close.png";
import avatarDefault from "../../imgs/figma_icons/avatar-default.png";
import iconGmailColored from "../../imgs/figma_icons/icon-gmail-colored.png";
import iconBankTeal from "../../imgs/figma_icons/icon-bank-teal.png";
import iconEyeSlash from "../../imgs/figma_icons/icon-eye-slash.png";
import iconInfoCircle from "../../imgs/figma_icons/icon-info-circle.png";
import actionName from "../../imgs/figma_icons/action-name.png";
import actionPhone from "../../imgs/figma_icons/action-phone.png";
import actionGmail from "../../imgs/figma_icons/action-gmail.png";
import actionBank from "../../imgs/figma_icons/action-bank.png";
import actionPassLogin from "../../imgs/figma_icons/action-pass-login.png";
import actionPassWithdraw from "../../imgs/figma_icons/action-pass-withdraw.png";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { apiGetRequestHistory } from "../../services/api.service.js";
import {
  requestStatusText,
  requestTypeText,
  getVerificationStatusText,
  maskRequestCode,
} from "../../utils/requestHistory.js";

function Profile() {
  const location = useLocation();
  const { userName, data, webSetting } = location.state || {};
  const navigate = useNavigate();
  const [requestCode, setRequestCode] = useState("");
  const [requestHistory, setRequestHistory] = useState(null);
  const [requestHistoryError, setRequestHistoryError] = useState("");
  const [openRequestHistoryResult, setOpenRequestHistoryResult] =
    useState(false);
  const [showRequestHistoryHelp, setShowRequestHistoryHelp] = useState(false);
  const [showBankNumber, setShowBankNumber] = useState(false);
  const [recentRequests, setRecentRequests] = useState(
    (data?.recent_requests || []).slice(0, 2),
  );

  useEffect(() => {
    setRecentRequests((data?.recent_requests || []).slice(0, 2));
  }, [data?.recent_requests]);

  const shouldNavigate = !userName || userName === "undefined";
  useEffect(() => {
    if (shouldNavigate) {
      navigate("/");
    }
  }, [navigate, shouldNavigate]);

  if (!shouldNavigate) {
    const changeInfo = async (typeModal) => {
      if (!userName) {
        return Swal.fire({
          icon: "error",
          text: "Vui lòng nhập tên tài khoản.",
        });
      }
      navigate("/change-info", {
        state: {
          userName,
          data: { ...data, recent_requests: recentRequests },
          webSetting,
          typeModal,
        },
      });
    };

    const checkRequestHistory = async () => {
      const code = requestCode.trim();
      setRequestHistoryError("");
      if (!/^\d{8}$/.test(code)) {
        setRequestHistoryError("Vui lòng nhập đúng mã yêu cầu gồm 8 số.");
        return;
      }
      const result = await apiGetRequestHistory(userName, code);
      if (result?.code === 200 && result?.data?.request) {
        setRequestHistory(result.data.request);
        setOpenRequestHistoryResult(true);
      } else {
        setRequestHistoryError(result?.message || "Không tìm thấy yêu cầu.");
      }
    };

    const getMaskedBankNumber = (number) => {
      if (!number) return "Chưa cập nhật";
      if (showBankNumber) return number;
      if (number.includes("*")) return number;
      if (number.length <= 4) return number;
      return "*".repeat(Math.max(4, number.length - 4)) + number.slice(-4);
    };

    const getMaskedPhoneNumber = (phone) => {
      if (!phone) return "Chưa cập nhật";
      if (phone.includes("*")) return phone;
      if (phone.length <= 6) return phone;
      return phone.slice(0, 3) + "****" + phone.slice(-3);
    };

    const getMaskedEmail = (email) => {
      if (!email) return "Chưa cập nhật";
      if (email.includes("*")) return email;
      const parts = email.split("@");
      if (parts.length < 2) return email;
      const name = parts[0];
      const maskedName =
        name.length <= 3 ? name + "****" : name.slice(0, 3) + "****";
      return maskedName + "@" + parts[1];
    };

    return (
      <div className="container">
        <motion.div
          className="app app-profile"
          initial={{ x: "100vw", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "-100vw", opacity: 0 }}
          transition={{
            type: "spring",
            stiffness: 1000,
            damping: 200,
            duration: 10,
          }}
        >
          <Header isPageSearch={false} webSetting={webSetting} />

          <div className="content">
            <div className="profile">
              {/* Card thông tin người dùng theo Figma Frame 3 */}
              {/* <div className="profile-user-card">
                <div className="profile-user-header">
                  <div className="profile-user-avatar">
                    <img src={avatarDefault} alt="Avatar" />
                  </div>
                  <div className="profile-user-meta">
                    <h2 className="profile-user-name">
                      {(data?.Name || data?.name || userName || "").toUpperCase()}
                    </h2>
                    <div className="profile-user-phone">
                      <span>Số điện thoại:</span>{" "}
                      <strong>{getMaskedPhoneNumber(data?.phone_number)}</strong>
                    </div>
                  </div>
                </div>

                <div className="profile-email-box">
                  <img
                    src={webSetting?.icon_email || iconGmailColored}
                    alt="Gmail"
                    className="profile-gmail-icon"
                  />
                  <span className="profile-email-text">
                    {getMaskedEmail(data?.email)}
                  </span>
                </div>

                <div className="profile-bank-box">
                  <div className="profile-bank-heading">
                    <img
                      src={webSetting?.icon_bank || iconBankTeal}
                      alt="Bank"
                      className="profile-bank-icon"
                    />
                    <span>Thông Tin Ngân hàng</span>
                  </div>
                  <div className="profile-bank-details">
                    <span>
                      Ngân hàng: <strong>{data?.bank_name || "Chưa cập nhật"}</strong>
                    </span>
                    <span>
                      Chi nhánh: <strong>{data?.Province || data?.province || data?.bank_branch || "Chưa cập nhật"}</strong>
                    </span>
                  </div>
                  <div className="profile-bank-number-row">
                    <span className="profile-bank-number-label">
                      Số TK: <strong>{getMaskedBankNumber(data?.bank_number)}</strong>
                    </span>
                  </div>
                </div>
              </div> */}

              {/* Phần Lịch sử yêu cầu */}
              <div className="request-history-section">
                <div className="request-history-heading">
                  <span className="request-history-title">LỊCH SỬ YÊU CẦU</span>
                  <button
                    type="button"
                    className="request-history-help-btn"
                    onClick={() => setShowRequestHistoryHelp((v) => !v)}
                    onMouseEnter={() => setShowRequestHistoryHelp(true)}
                    onMouseLeave={() => setShowRequestHistoryHelp(false)}
                    aria-label="Thông tin lịch sử yêu cầu"
                  >
                    <img src={webSetting?.icon_clock || iconInfoCircle} alt="Thông tin" />
                  </button>
                  {showRequestHistoryHelp && (
                    <div className="request-history-help-tooltip">
                      Danh sách chỉ hiển thị tối đa 2 yêu cầu gần nhất trong 48
                      giờ. Nhập mã yêu cầu 8 số để xem chi tiết kết quả xử lý.
                    </div>
                  )}
                </div>

                {recentRequests.length > 0 && (
                  <div className="recent-requests">
                    {recentRequests.map((request, index) => (
                      <div
                        className={`recent-request-item status-${request.status}`}
                        key={`${request._request_code || request.request_code}-${index}`}
                      >
                        <div className="recent-request-main">
                          <strong>
                            {requestTypeText[request.update_type] ||
                              request.update_type}
                          </strong>
                          <span className="recent-request-code">
                            {maskRequestCode(request.request_code)}
                          </span>
                        </div>
                        <div className="recent-request-meta">
                          <span
                            className={`recent-request-status status-${request.status}`}
                          >
                            {requestStatusText[request.status] ||
                              request.status}
                          </span>
                          {request.status === "no_process" &&
                            ["email", "phone_number"].includes(
                              request.send_type,
                            ) && (
                              <span
                                className={`verification-status verification-${request.verification_status || "not_received"}`}
                              >
                                {getVerificationStatusText(
                                  request.verification_status || "not_received",
                                  request.send_type,
                                )}
                              </span>
                            )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                <div className="input-search-pill request-history-search">
                  <input
                    className="input-account-pill"
                    type="text"
                    inputMode="numeric"
                    maxLength="8"
                    value={requestCode}
                    onChange={(event) => {
                      setRequestCode(event.target.value.replace(/\D/g, ""));
                      setRequestHistoryError("");
                    }}
                    onKeyDown={(event) =>
                      event.key === "Enter" && checkRequestHistory()
                    }
                    placeholder="Nhập mã yêu cầu 8 số"
                  />
                  <button
                    type="button"
                    className="btn-search-account-pill"
                    onClick={checkRequestHistory}
                  >
                    KIỂM TRA
                  </button>
                </div>
                {requestHistoryError && (
                  <p className="request-history-error">
                    {requestHistoryError}
                  </p>
                )}
              </div>

              {/* Panel chứa 6 thẻ hành động theo Rectangle 161123955 trong Figma Frame 3 */}
              <div className="profile-actions-panel">
                <div className="action-cards-grid">
                  <div
                    className="action-card-item"
                    onClick={() => changeInfo("full_name")}
                  >
                    <div className="action-card-icon">
                      <img src={webSetting?.icon_user || actionName} alt="Thay đổi họ và tên" />
                    </div>
                    <span className="action-card-label">THAY ĐỔI HỌ VÀ TÊN</span>
                  </div>

                  <div
                    className="action-card-item"
                    onClick={() => changeInfo("phone_number")}
                  >
                    <div className="action-card-icon">
                      <img src={webSetting?.icon_phone || actionPhone} alt="Thay đổi SĐT" />
                    </div>
                    <span className="action-card-label">THAY ĐỔI SĐT</span>
                  </div>

                  <div
                    className="action-card-item"
                    onClick={() => changeInfo("email")}
                  >
                    <div className="action-card-icon">
                      <img src={webSetting?.icon_email || actionGmail} alt="Thay đổi Gmail" />
                    </div>
                    <span className="action-card-label">THAY ĐỔI GMAIL</span>
                  </div>

                  <div
                    className="action-card-item"
                    onClick={() => changeInfo("bank")}
                  >
                    <div className="action-card-icon">
                      <img src={webSetting?.icon_bank || actionBank} alt="Đổi STK ngân hàng" />
                    </div>
                    <span className="action-card-label">ĐỔI STK NGÂN HÀNG</span>
                  </div>

                  <div
                    className="action-card-item"
                    onClick={() => changeInfo("forget_password")}
                  >
                    <div className="action-card-icon">
                      <img src={webSetting?.icon_wallet || actionPassLogin} alt="Mật khẩu đăng nhập" />
                    </div>
                    <span className="action-card-label">MẬT KHẨU ĐĂNG NHẬP</span>
                  </div>

                  <div
                    className="action-card-item"
                    onClick={() => changeInfo("forget_password_withdraw")}
                  >
                    <div className="action-card-icon">
                      <img src={webSetting?.icon_clock || actionPassWithdraw} alt="Mật khẩu rút tiền" />
                    </div>
                    <span className="action-card-label">MẬT KHẨU RÚT TIỀN</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Popup

            open={openRequestHistoryResult}
            onClose={() => setOpenRequestHistoryResult(false)}
            position="center"
            closeOnDocumentClick
            overlayStyle={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(0, 0, 0, 0.35)",
            }}
            contentStyle={{
              position: "relative",
              inset: "auto",
              width: "auto",
              padding: 0,
              border: "none",
              background: "transparent",
            }}
          >
            <div className="request-history-modal">
              <button
                className="request-history-modal-close"
                onClick={() => setOpenRequestHistoryResult(false)}
              >
                <img src={modalClose} alt="Đóng" />
              </button>
              {requestHistory && (
                <div
                  className={`request-history-result status-${requestHistory.status}`}
                >
                  <h3>KẾT QUẢ YÊU CẦU</h3>
                  <p>
                    <strong>Loại yêu cầu:</strong>{" "}
                    {requestTypeText[requestHistory.update_type] ||
                      requestHistory.update_type}
                  </p>
                  {requestHistory.data_update?.content && (
                    <p>
                      <strong>Nội dung yêu cầu:</strong>{" "}
                      {requestHistory.data_update.content}
                    </p>
                  )}
                  <p>
                    <strong>Trạng thái:</strong>{" "}
                    {requestStatusText[requestHistory.status] ||
                      requestHistory.status}
                  </p>
                  {requestHistory.status === "no_process" &&
                    ["email", "phone_number"].includes(
                      requestHistory.send_type,
                    ) && (
                      <p
                        className={`verification-status verification-${requestHistory.verification_status || "not_received"}`}
                      >
                        {getVerificationStatusText(
                          requestHistory.verification_status || "not_received",
                          requestHistory.send_type,
                        )}
                      </p>
                    )}
                  {(requestHistory.note || requestHistory.result) && (
                    <div className="request-result-note">
                      <strong>Ghi chú/Kết quả:</strong>
                      <HtmlNote
                        html={requestHistory.note || requestHistory.result}
                      />
                    </div>
                  )}
                  {requestHistory.createdAt && (
                    <p>
                      <strong>Ngày gửi:</strong>{" "}
                      {new Date(requestHistory.createdAt).toLocaleString(
                        "vi-VN",
                      )}
                    </p>
                  )}
                </div>
              )}
            </div>
          </Popup>
        </motion.div>
      </div>
    );
  }
}

export default Profile;
